import React from "react";
import { useTranslation } from "react-i18next";

import ReactPaginate from "react-paginate";
//functions
import { paginationLoading } from "../../functions/Functions";
import CustomSpinLoader from "../components/CustomSpinLoader";


const DataTable = (props) => {

    const { t } = useTranslation();

    const {
        columns = [],
        data = [],
        loading = false,
        emptyText = "No data available",
        pagination = {
            isPageLoading: false,
            isPagination: false,
            pageCount: 1,
            currentPage: 1,
            from: 0,
            to: 0,
            total: 0,
        },
        handleFetchData = () => { },
        searchPayload = {
            isSearched: false,
            searchData: [],
            onClearSearch: () => { },
        },
        theadClass = "fk-scroll--2--pos-table"
    } = props;

    const onPageChange = (page) => {
        handleFetchData(page.selected + 1);
    }

    const pageCount = Number(pagination?.pageCount || 1) || 1;
    const currentPage = Number(pagination?.currentPage || 1) || 1;
    const forcePage = Math.max(0, Math.min(pageCount - 1, currentPage - 1));

    return (
        <div className="">
            <div className="t-bg-white" data-simplebar>
                <div className="t-pl-15 t-pr-15">
                    {/* Loader */}
                    {loading && (
                        <div>
                            <CustomSpinLoader color="primary" loading={loading} />
                        </div>
                    )}


                    {/* Table */}
                    <div className={`table-responsive ${theadClass}`}>
                        <table className="table table-bordered table-hover min-table-height sticky-table-header">
                            <thead className="align-middle">
                                <tr>
                                    {columns.map((col, i) => (
                                        <th
                                            key={i}
                                            className="sm-text text-capitalize text-center"
                                            style={{ 
                                                width: col?.width || "auto",
                                                minWidth: col?.minWidth || "",
                                            }}
                                        >
                                            {col?.labelRender ? col?.labelRender() : (col?.header ? col.header : col.label)}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={columns.length} className="text-center py-3">
                                            {t(emptyText)}
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, i) => (
                                        <tr key={i}>
                                            {columns.map((col, j) => (
                                                <td key={j} className="xsm-text text-capitalize align-middle text-center">
                                                    {col.render ? col.render(item, i) : item[col.key]}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {/* Pagination */}

            {pagination.isPageLoading ? (
                paginationLoading()
            ) : searchPayload?.isSearched ? (
                <div className="t-bg-white mt-1 t-pt-5 t-pb-5">
                    <div className="row align-items-center t-pl-15 t-pr-15">
                        <div className="col-md-7 t-mb-15 mb-md-0">
                            <ul className="t-list d-flex">
                                <li className="t-list__item no-pagination-style">
                                    {searchPayload?.onClearSearch && (
                                        <button
                                            className="btn btn-primary btn-sm"
                                            onClick={searchPayload.onClearSearch}
                                        >
                                            {t("Clear Search")}
                                        </button>
                                    )}
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-5">
                            <ul className="t-list d-flex justify-content-md-end align-items-center">
                                <li className="t-list__item">
                                    <span className="d-inline-block sm-text">
                                        Showing {data.length} of {pagination?.to}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (
                <div key="fragment4">
                    <div className="t-bg-white mt-1 pb-1">
                        <div className="row align-items-center t-pl-15 t-pr-15">
                            <div className="col-md-7 t-mb-15 mb-md-0">
                                {/* pagination function */}
                                {pagination.isPagination && (
                                    <div className="t-bg-white mt-2 mb-1 t-pt-3 t-pb-3">
                                        <ReactPaginate
                                            pageCount={pageCount}
                                            forcePage={forcePage}
                                            marginPagesDisplayed={5}
                                            pageRangeDisplayed={2}
                                            onPageChange={onPageChange}
                                            breakLabel=". . ."
                                            breakClassName="px-2"
                                            containerClassName="t-list d-flex"
                                            pageClassName="t-list__item mr-0"
                                            previousLabel={<i className="las la-angle-double-left"></i>}
                                            nextLabel={<i className="las la-angle-double-right"></i>}
                                            pageLinkClassName="t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                            previousClassName="t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                            nextClassName="t-link t-pt-5 t-pb-5 t-pl-10 t-pr-10 paginav__link paginav__link--light border text-capitalize sm-text"
                                            activeClassName="pagination-active"
                                            activeLinkClassName="text-white"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="col-md-5">
                                <ul className="t-list d-flex justify-content-md-end align-items-center">
                                    <li className="t-list__item">
                                        {pagination?.isPagination && (
                                            <span className="d-inline-block sm-text">
                                                Showing {pagination.from} - {pagination?.to} of {pagination?.total}
                                            </span>
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default DataTable;
